import { useQuery } from '@tanstack/react-query';
import { getAccountInfo } from '../../../api/accounts';
import { GetCurrentAccountInfoResponse } from '../../../types/Account';

export const useCurrentAccountData = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: GetCurrentAccountInfoResponse) => void;
  onError?: (err: any) => void;
}) => {
  return useQuery(['get-current-account-info'], getAccountInfo, {
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
